import React, { useState, useEffect } from 'react';
import ComboBox from 'Components/ComboBox/ComboBox';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import Panel from 'Components/Panel/Panel';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';

function UserCalendarFilter({
    onUpdateSectorSelected,
    onUpdateManagerSelected,
    onUpdateEmployeeSelected,
    onUpdateSelectedActualDate,
    selectedActualDate,
    sectorSelected,
    managerSelected,
    sectorEmployees,
    employeeSelected,
    sectors
}) {
    const [managers, setManagers] = useState([]);
    const [employees, setEmployees] = useState([]);

    const cleanManager = () => {
        setManagers([])
        onUpdateManagerSelected("")
    }

    const cleanEmployee = () => {
        setEmployees([]);
    }

    useEffect(() => {
        if (sectorSelected) {
            const fetchManagers = async () => {

                cleanManager()
                cleanEmployee()
                const parameters = {
                    sectorId: parseInt(sectorSelected),
                    roleId: null
                }
                const managers = await ExecuteAxios.api('get', `/employee/lookup-manager-and-employee/`, { params: parameters });
                setManagers(managers);
            };

            fetchManagers();
        } else {
            cleanManager()
        }
    }, [sectorSelected]);

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)
    const managerOptions = OptionsDataByAttributePath(managers, ['description'], null, true)
    const employeeOptions = OptionsDataByAttributePath(employees, ['description'], null, true)

    useEffect(() => {
        if (sectorSelected) {
            setEmployees([]);
            const fetchEmployees = async () => {
                const parameters = {
                    sectorId: sectorSelected,
                    managerId: managerSelected,
                    roleId: null
                };
                setEmployees(await ExecuteAxios.api('get', '/employee/lookup-manager-and-employee/', { params: parameters }));
            };
            fetchEmployees();
        }
    }, [sectorSelected, managerSelected]);

    const mainPanelStyle = {
        flexDirection: 'column',
        display: 'flex',
        '--modal-width-left': '20%'
    };

    const styleCombox = {
        marginBottom: '20px',
        flexDirection: 'column',
        display: 'flex',
        flexGrow: '1'
    }

    return (
        <Panel style={mainPanelStyle} className={'main-modal three left'}>
            <Panel style={{ margin: '4%', display: 'flex', flexDirection: 'column' }} className={'calendar-filter'}>
                <h3 style={{ marginTop: '5%', marginBottom: '5%' }}> Filtros</h3>
                <Panel style={styleCombox} className={'calendar-filter-fields'}>
                    <span>Setor</span>
                    <ComboBox setAttribute={onUpdateSectorSelected}
                        optionsData={sectorOptions}
                        style={{ marginBottom: '25px' }}
                        value={sectorSelected}
                        defaultValue={sectorSelected}
                    />

                    <span>Colaborador</span>
                    <ComboBox setAttribute={onUpdateEmployeeSelected}
                        optionsData={employeeOptions}
                        style={{ marginBottom: '25px' }}
                        value={employeeSelected}
                        defaultValue={employeeSelected}
                    />

                    <span>Mês/Ano</span>
                    <ReactDataPickerComp
                        selected={selectedActualDate}
                        onChange={(date) => { onUpdateSelectedActualDate(date) }}
                        wrapperClassName={'width-full'}
                        className='validate-attribute width-full cursor-pointer'
                        showMonthYearPicker={true}
                        dateFormat={'MM/yyyy'}
                        setter={onUpdateSelectedActualDate}
                    />
                </Panel>
            </Panel>
        </Panel >
    );
}

export default UserCalendarFilter;